import {Dialog, openConfirmDialog} from 'platform/components';
import {Box} from 'platform/foundation';

import {useState} from 'react';

import {isNil} from 'ramda';

import {useLazyGetBusinessCaseQuery, useLinkTradeInMutation} from '@dms/api/sales';
import i18n from '@dms/i18n';
import {testIds} from '@dms/routes';
import {DmsDataGrid, handleApiError} from '@dms/shared';

interface TradeInSelectCounterpartDialogProps {
  businessCaseId: string;
  hostCustomerId: string;
  hostBranchId: string;
  gridCode: string;
  titleKey: string;
  onClose: () => void;
}

export function TradeInSelectCounterpartDialog(props: TradeInSelectCounterpartDialogProps) {
  const [selectedCounterpartId, setSelectedCounterpartId] = useState<string>();
  const [getBusinessCase] = useLazyGetBusinessCaseQuery();
  const [linkTradeIn] = useLinkTradeInMutation();

  const link = () => {
    if (isNil(selectedCounterpartId)) {
      return;
    }
    linkTradeIn({
      businessCaseId: props.businessCaseId,
      linkTradeInRequestBody: {counterpartBusinessCaseId: selectedCounterpartId},
      xBranch: props.hostBranchId,
    })
      .unwrap()
      .then(props.onClose)
      .catch(handleApiError);
  };

  const handleSubmit = () => {
    if (isNil(selectedCounterpartId)) {
      return;
    }
    getBusinessCase({businessCaseId: selectedCounterpartId})
      .unwrap()
      .then((counterpart) => {
        if (counterpart.customerId !== props.hostCustomerId) {
          openConfirmDialog({
            text: i18n.t('page.businessCase.tradeIn.customerMismatch'),
            onConfirm: link,
          });
          return;
        }
        link();
      })
      .catch(handleApiError);
  };

  return (
    <Dialog
      data-testid={testIds.businessCase.detail('selectTradeInCounterpart')}
      size="large"
      isOpen
      onClose={props.onClose}
      title={i18n.t(props.titleKey)}
      buttons={[
        {title: i18n.t('general.actions.cancel'), variant: 'secondary', onClick: props.onClose},
        {
          title: i18n.t('general.labels.select'),
          variant: 'primary',
          onClick: handleSubmit,
          isDisabled: isNil(selectedCounterpartId),
        },
      ]}
    >
      <Box height="60vh">
        <DmsDataGrid
          gridCode={props.gridCode}
          onRowSelectionChange={(rows) => setSelectedCounterpartId(rows[0]?.id)}
          data-testid={testIds.businessCase.detail('tradeInCounterpartGrid')}
        />
      </Box>
    </Dialog>
  );
}
